import React from 'react';
import { Grid } from '@nextiva/next-ui-components';

export const ShadowDom = () => {
  const rows = [];

  for (let i = 0; i < 5; i++) {
    rows.push(
      <div className="m-shadow-team-list__row" key={`shadow_row${i}`}>
        <Grid container>
          <Grid item xs={4}>
            <div className="m-shadow-team-list__row__data" />
          </Grid>
          <Grid item xs={4}>
            <div className="m-shadow-team-list__row__data" />
          </Grid>
          <Grid item xs={4}>
            <div className="m-shadow-team-list__row__data" />
          </Grid>
        </Grid>
      </div>,
    );
  }

  return <div className="m-shadow-team-list">{rows}</div>;
};
